// "no-unknown-property" is broken so disabling it...
/* eslint-disable react/no-unknown-property */
import React from 'react'
import { makeStyles, Checkbox } from '@material-ui/core'
// import { clickAudio, hoverAudio } from './common-vuplex-messages';
import CheckIcon from '@material-ui/icons/Check'
import GlueIcon from './glue-icon'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    height: theme.custom.glueListItem.height,

    background: ({ selected }) => selected ? theme.palette.listItem.active : theme.palette.listItem.main,
    color: ({ selected }) => selected ? theme.palette.listItem.textActive : theme.palette.listItem.contrastText,
    opacity: ({ disabled }) => disabled ? '50%' : '100%'
  },

  background: {
    width: '100%',
    height: '100%',
    padding: `0px ${theme.spacing('s')}`,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing('s'),

    '&:hover': {
      background: theme.palette.listItem.hover,
      color: theme.palette.listItem.textHover
    }
  },

  text: {
    width: '100%',
    whiteSpace: ({ noTruncate }) => noTruncate ? 'none' : 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: 'auto',
    lineHeight: 1
  },

  divider: {
    display: ({ divider }) => divider ? 'block' : 'none',
    height: '2px',
    background: theme.palette.secondary.main, // Could be a separate definition
    position: 'relative',
    bottom: '2px'
  }

}), { name: 'MuiGlueListItem' })

const GlueListItem = (props) => {
  const classes = useStyles(props)

  // const audiomessage = props.uiAudioMessage ? props.uiAudioMessage : 'Menu/Generic/Button/Press'
  // const hoveraudiomessage = props.uiHoverAudioMessage ? props.uiHoverAudioMessage : 'Menu/Generic/Button/HL'

  const onClick = () => {
    if (!props.disabled) {
      // clickAudio(audiomessage)
      if (props.onPointerDown) {
        props.onPointerDown()
      }
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.background} onPointerDown={onClick} /* onPointerEnter={() => { hoverAudio(hoveraudiomessage) }} */>
        {props.checkbox
          ? <GlueIcon>
            <Checkbox checked={props.selected} />
          </GlueIcon>
          : <GlueIcon>
            {props.selected && <CheckIcon />}
          </GlueIcon>}
        <p className={classes.text}>{props.children}</p>
      </div>
      <div className={classes.divider} />
    </div>
  )
}

export default GlueListItem
